export default __webpack_public_path__ + "static/media/banner1.e924c339.jpg";